import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Contact.heading',
    defaultMessage: 'Kontakt'
  },
  contactWithUs: {
    id: 'views.Contact.contactWithUs',
    defaultMessage: 'SKONTAKTUJ SIĘ Z NAMI!'
  }
});



// WEBPACK FOOTER //
// ./src/views/Contact/Contact.intl.js